let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g4yQd")).then(() => parcelRequire('GmN1W'));